import { ActionMenu, font, TransparentButton } from '@approvalmax/ui';
import { LineItemsTable } from 'pages/requestList/components/lineItemsSection/LineItemsTable';
import styled, { css } from 'styled-components';

export const Root = styled.div`
    height: 92%;
    display: flex;
    flex-direction: column;
    padding: 12px 60px;
`;

export const EmptyState = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const EmptyText = styled.div`
    margin-top: 20px;
    ${font(16, '#000', 'semibold')}
`;

export const StyledActionMenu = styled(ActionMenu)`
    opacity: 0;
    transition: opacity 0.3s ease-in;
    pointer-events: none;

    &:focus-within {
        opacity: 1;
        pointer-events: auto;
    }
`;

export const StyledLineItemsTable = styled(LineItemsTable)`
    && {
        overflow: initial;
        overflow-y: initial;
    }

    tbody tr:hover {
        ${StyledActionMenu} {
            opacity: 1;
            pointer-events: auto;
        }
    }
`;

export const TableContainer = styled.div`
    width: 100%;
    overflow: auto;
`;

export const ActionButton = styled(TransparentButton)`
    padding: 8px 4px;
`;

export const FieldContainer = styled.div<{ width: number }>`
    ${(props) => css`
        width: ${props.width}px;
    `}
`;
